
import { formatMoney } from '@theme/money-formatting';

(function () {
  'use strict';

  var HOECHSTENS = 12;

  var lage = 'normal';

  var offeneRefs = [];
  var offeneNamen = [];

  var monitore = [];
  var letzteMonitore = '';

  var ARTEN = {
    tisch: ['tischhalterung'],
    wand: ['wandhalterung_fix', 'wandhalterung_arm']
  };

  function istOne(eintrag) { return eintrag.kind === 'one'; }

  function nachEmpfehlung(liste) {
    var rang = { spar: 0, zweiter: 1 };
    return liste
      .map(function (e, i) { return { e: e, i: i }; })
      .sort(function (a, b) {
        var ra = rang.hasOwnProperty(a.e.empfehlung) ? rang[a.e.empfehlung] : 2;
        var rb = rang.hasOwnProperty(b.e.empfehlung) ? rang[b.e.empfehlung] : 2;
        return ra - rb || a.i - b.i;
      })
      .map(function (x) { return x.e; });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var SK_T = null;
  function skT(schluessel, rueckfall, werte) {
    if (SK_T === null) {
      SK_T = {};
      try {
        var el = document.querySelector('script[data-sk-texte]');
        if (el) SK_T = JSON.parse(el.textContent) || {};
      } catch (e) { SK_T = {}; }
    }
    var s = String(SK_T[schluessel] || rueckfall || '');
    if (werte) {
      Object.keys(werte).forEach(function (k) {
        s = s.split('{' + k + '}').join(String(werte[k]));
      });
    }
    return s;
  }

  function auswahlLesen() {
    try {
      var roh = JSON.parse(localStorage.getItem('3idee_auswahl') || 'null');
      if (!roh || !roh.refs || !roh.refs.length) return null;
      return roh.refs.map(String);
    } catch (e) { return null; }
  }

  function tischLesen() {
    try {
      var roh = JSON.parse(localStorage.getItem('3idee_auswahl') || 'null');
      var t = roh && roh.tisch;
      if (!t || (!t.art && !t.dicke_cm)) return null;
      return t;
    } catch (e) { return null; }
  }

  function proxyVon(block) {
    return (window.FinderClean && window.FinderClean.proxy)
      || block.getAttribute('data-sku-proxy-fallback') || '/apps/monitor-db';
  }

  function abruf(url) {
    if (window.EngineStatus) return window.EngineStatus.hol(url);
    return fetch(url).then(function (r) { return r.json(); });
  }

  var WA_TEXT = 'Hallo, ich suche eine Halterung. Mein Monitor ist: ';

  function holen(proxy, refs, arten) {
    var qs = refs.map(function (r) { return 'm=' + encodeURIComponent(r); })
      .concat(arten.map(function (a) { return 'mount_type=' + encodeURIComponent(a); }))
      .join('&');

    var tisch = tischLesen();
    if (tisch && tisch.dicke_cm && arten.indexOf('tischhalterung') > -1) {
      qs += '&table_thickness_mm=' + encodeURIComponent(Number(tisch.dicke_cm) * 10);
    }

    return abruf(proxy + '/combinations/compatible?' + qs)
      .then(function (json) {
        if (!json || !json.ok) return [];
        var combos = (json.data && json.data.combinations) || [];

        var gesehen = {}, liste = [];
        combos.forEach(function (c) {
          var p = c.product;
          if (!p || !p.handle || p.in_shop === false) return;
          if (c.status && c.status !== 'visible') return;
          if (gesehen[p.handle]) {
            if (c.empfehlung && !gesehen[p.handle].empfehlung) gesehen[p.handle].empfehlung = c.empfehlung;
            return;
          }
          var pflichtplatte = (c.fit === 'bundle' && c.requires && c.requires[0]) ? c.requires[0] : null;
          var eintrag = {
            handle: p.handle,
            empfehlung: c.empfehlung || null,
            name: p.name || '',
            kind: c.kind || '',
            sku: (p && p.shopify_sku) || c.sku || '',
            platteSku: (pflichtplatte && pflichtplatte.sku) || '',
            platteStueck: (pflichtplatte && pflichtplatte.qty) || 1,
            gewicht: (c.weight_kg != null ? Number(c.weight_kg) : null),
            setupGewicht: (c.setup_weight_kg != null ? Number(c.setup_weight_kg) : null),
            knapp: c.traglast === 'knapp',
            aufbau: c.base || '',
            anordnung: (c.labels && c.labels.arrangement) || c.layout || '',
            arme: Number(c.monitors) || 0
          };
          gesehen[p.handle] = eintrag;
          liste.push(eintrag);
        });
        var wurzel = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        return Promise.all(liste.map(function (e) {
          if (!e.sku) return Promise.resolve(e);
          return fetch(wurzel + 'products/' + encodeURIComponent(e.handle) + '.js')
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (pr) {
              if (!pr || !pr.variants) return e;
              var soll = String(e.sku).toLowerCase();
              return pr.variants.some(function (v) { return String(v.sku || '').toLowerCase() === soll; }) ? e : null;
            }, function () { return e; });
        })).then(function (geprueft) { return geprueft.filter(Boolean); });
      })
      .catch(function (e) {
        return (e && e.engineAus && window.EngineStatus) ? null : [];
      });
  }

  function bundleHtml(eintrag, block) {
    if (!istOne(eintrag)) return '';

    var proPaar = Number(block.getAttribute('data-sku-bundle')) || 0;
    var arme = Number(eintrag.arme) || 0;
    if (!proPaar || !arme) return '';

    var betrag = proPaar * arme;
    var wort = arme === 1
      ? (block.getAttribute('data-sku-bundle-wort') || '')
      : (block.getAttribute('data-sku-bundle-wort-mehr') || '').replace('%d', arme);

    return '<span class="vorteil-etikett">\u2212' + betrag + '\u00a0\u20ac'
      + (wort ? ' ' + esc(wort.trim()) : '') + '</span>';
  }

  function kurzzeile(eintrag) {
    return '<span class="lw__kurz" data-lw-kurz></span>';
  }

  function kurzzeileFuellen(zeile, hd) {
    var el = zeile.querySelector('[data-lw-kurz]');
    if (!el) return;

    var etikett = (hd && hd.badge) || '';
    if (etikett) { el.textContent = etikett; return; }

    var teile = [];
    var kopf = (hd && (hd.kopf || hd.system)) || '';
    if (kopf) teile.push(kopf);

    var wieviele = (hd && hd.monitore) || '';
    if (!wieviele) {
      var arme = Number(zeile.getAttribute('data-lw-arme')) || 0;
      if (arme) wieviele = arme === 1
        ? skT('monitor_eins', '{n} Monitor', { n: arme })
        : skT('monitor_mehrere', '{n} Monitore', { n: arme });
    }
    if (wieviele) teile.push(wieviele);

    if (!teile.length && hd && hd.anordnung) teile.push(hd.anordnung);
    el.textContent = teile.join(' · ');
  }

  function vorteilEtikett(block, arme, einheitenAus) {
    var proPaar = Number(block.getAttribute('data-sku-bundle')) || 0;
    arme = Number(arme) || 0;
    if (!proPaar || !arme) return '';

    var einheiten = einheitenAus;
    if (einheiten == null) {
      var gew = gewaehlteTeile(block);
      var gewaehlt = 0;
      gew.forEach(function (t) { if (t.art === 'ADAPTER') gewaehlt += t.anzahl; });

      if (!gewaehlt) return '';
      einheiten = Math.min(gewaehlt, arme);
    }
    if (einheiten < 1) return '';

    var betrag = proPaar * einheiten;
    var wort = einheiten === 1
      ? (block.getAttribute('data-sku-bundle-wort') || '')
      : (block.getAttribute('data-sku-bundle-wort-mehr') || '').replace('%d', einheiten);
    return '<span class="vorteil-etikett">−' + betrag + ' €'
      + (wort ? ' ' + esc(wort.trim()) : '') + '</span>';
  }

  function etikettenNachziehen(block) {
    block.querySelectorAll('.sku__karte .sku__preiszeile .vorteil-etikett').forEach(function (e) {
      e.remove();
    });
  }

  function karteHtml(eintrag, block) {
    return '<div class="sku__karte" role="radio" aria-checked="false" tabindex="0"'
      + ' data-mini-handle="' + esc(eintrag.handle) + '"'
      + ' data-lw-arme="' + (Number(eintrag.arme) || 0) + '"'
      + ' data-lw-one="' + (istOne(eintrag) ? '1' : '0') + '"'
      + (eintrag.gewicht != null ? ' data-lw-kg="' + eintrag.gewicht + '"' : '')
      + (eintrag.setupGewicht != null ? ' data-lw-setup-kg="' + eintrag.setupGewicht + '"' : '')
      + (eintrag.sku ? ' data-lw-sku="' + esc(eintrag.sku) + '"' : '')
      + (eintrag.platteSku ? ' data-lw-platte-sku="' + esc(eintrag.platteSku) + '"'
                           + ' data-lw-platte-stueck="' + (Number(eintrag.platteStueck) || 1) + '"' : '')
      + '>'
      + '<span class="lw__radio" aria-hidden="true"></span>'
      + '<span class="sku__bild" data-mini-bild></span>'
      + '<span class="sku__name" data-mini-titel>' + esc(eintrag.name) + '</span>'
      + kurzzeile(eintrag)
      + (eintrag.knapp ? '<span class="lw__traglast">'
          + esc(block.getAttribute('data-lw-wort-knapp') || 'Nahe an der Traglast') + '</span>' : '')
      + '<span class="sku__preiszeile">'
      +   '<span class="sku__preis" data-lw-preis></span>'
      +   '<span class="sku__streich" data-lw-streich></span>'
      + '</span>'
      + '</div>';
  }

  function reihenFuellen(block, pruefung, gruppen, geprueft) {
    var namen = ['one', 'tisch', 'wand'];
    var gesamt = 0, vorhanden = [];

    namen.forEach(function (gruppe) {
      var liste = (gruppen[gruppe] || []).slice(0, HOECHSTENS);
      gesamt += liste.length;
      if (liste.length) vorhanden.push(gruppe);

      var reihe = block.querySelector('[data-sku-reihe="' + gruppe + '"]');
      if (!reihe) return;
      reihe.innerHTML = liste.map(function (e) { return karteHtml(e, block); }).join('');
      if (liste.length) pruefung.__fckApi.karten(reihe);
    });

    if (!gesamt) return 0;

    block.__lwGruppen = vorhanden;
    tischzeileZeigen(block);

    var tischWahl = tischLesen();
    var tischGesagt = !!(tischWahl && (tischWahl.art || tischWahl.dicke_cm));
    var tischLoesungDa = vorhanden.indexOf('one') > -1 || vorhanden.indexOf('tisch') > -1;

    var ziel = vorhanden[0];
    if (tischGesagt && !tischLoesungDa) ziel = 'tisch';
    block.__lwZiel = ziel;

    block.querySelectorAll('[data-sku-tab]').forEach(function (tab) {
      var name = tab.getAttribute('data-sku-tab');
      var leer = vorhanden.indexOf(name) < 0;
      var wandZurueck = name === 'wand' && tischGesagt && tischLoesungDa;
      tab.hidden = false;
      tab.disabled = false;
      tab.removeAttribute('aria-disabled');
      tab.classList.toggle('sku__tab--leer', leer || wandZurueck);
      if (leer) tab.setAttribute('title', block.getAttribute('data-lw-reiter-leer') || '');
      else if (wandZurueck) tab.setAttribute('title', block.getAttribute('data-lw-reiter-tisch') || '');
      else tab.removeAttribute('title');
    });

    namen.forEach(function (gruppe) {
      if (vorhanden.indexOf(gruppe) > -1) return;
      var spur = block.querySelector('[data-sku-reihe="' + gruppe + '"]');
      if (!spur) return;
      var schluessel = gruppe === 'wand' ? 'data-lw-leer-wand'
                     : !tischGesagt      ? 'data-lw-reiter-leer'
                     : gruppe === 'one'  ? 'data-lw-leer-one'
                                         : 'data-lw-tisch-leer';
      spur.innerHTML = '<p class="lw__spur-leer">'
        + esc(block.getAttribute(schluessel) || '') + '</p>';
    });
    var schalter = block.querySelector('[data-sku-schalter]');
    if (schalter) schalter.hidden = false;

    umschalten(block, ziel);

    if (lage === 'normal') block.hidden = false;

    function behutsam(name, tun) {
      try { tun(); }
      catch (e) { if (window.console) console.error('Loesungswahl: ' + name, e); }
    }

    behutsam('bedienen', function () { bedienen(block); });
    behutsam('adapterpreis', function () { adapterpreisZeigen(block); });
    altLaden(block, function () {
      behutsam('korb', function () {
        korbLaden(function () {
          behutsam('zuordnung', function () { zuordnungZeigen(block); });
          behutsam('adapterpreis', function () { adapterpreisZeigen(block); });
          behutsam('preis', function () { preisZeigen(block); });
          behutsam('knopf', function () { knopfSetzen(block); });
        });
      });
      behutsam('preise', function () { setzePreise(block); });
      behutsam('zuordnung', function () { zuordnungZeigen(block); });
      behutsam('preis', function () { preisZeigen(block); });
      behutsam('knopf', function () { knopfSetzen(block); });
    });
    behutsam('preise', function () { setzePreise(block); });
    behutsam('mehr', function () { mehrRichten(block); });
    behutsam('knopf', function () { knopfSetzen(block); });

    block.setAttribute('data-sku-geprueft', geprueft ? 'ja' : 'nein');
    ungepruefetHinweis(block);

    var marke = block.querySelector('[data-sku-marke]');
    if (marke && lage !== 'normal') { marke.hidden = true; marke.innerHTML = ''; }
    else if (marke) {
      marke.innerHTML = geprueft
        ? '<span class="fck__vf fck__vf--satz">'
          +   '<span class="fck__vf-punkt" aria-hidden="true"></span>3IDEE VERIFIED'
          +   '<button class="fck__vf-i" type="button" data-fenster-auf="verified"'
          +     ' aria-label="' + esc(skT('verified_aria', 'Was bedeutet 3IDEE VERIFIED?')) + '">i</button>'
          + '</span>'
        : '<span class="sku__ungeprueft">'
          + esc(block.getAttribute('data-lw-wort-ungeprueft') || 'ungeprüft')
          + '</span>';
      vorbehaltWort(block);
    }

    if (lage !== 'normal') return;

    pfeileNachziehen(block);
    setTimeout(function () { pfeileNachziehen(block); }, 600);
    return gesamt;
  }

  function vorabAdresse(wert, artDerListe) {
    wert = (wert || '').trim();
    if (!wert) return '';
    var wurzel = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var pfad = artDerListe === 'tag'
      ? wurzel + 'collections/all/' + encodeURIComponent(wert)
      : wurzel + 'collections/types?q=' + encodeURIComponent(wert);
    var sortierung = artDerListe === 'tag' ? 'best-selling' : 'price-ascending';
    return pfad + (pfad.indexOf('?') > -1 ? '&' : '?')
      + 'sort_by=' + sortierung + '&section_id=halterungen-vorab';
  }

  function vorabHolen(adresse) {
    if (!adresse) return Promise.resolve([]);
    return fetch(adresse)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var roh = doc.querySelector('[data-halterungen-vorab]');
        return roh ? JSON.parse(roh.textContent) : [];
      })
      .catch(function () { return []; });
  }

  function vorabZeigen(block, pruefung, gestoert) {
    Promise.all([
      vorabHolen(vorabAdresse(block.getAttribute('data-sku-vorab-one'), 'tag')),
      vorabHolen(vorabAdresse(block.getAttribute('data-sku-vorab-tisch'), 'typ')),
      vorabHolen(vorabAdresse(block.getAttribute('data-sku-vorab-wand'), 'typ'))
    ]).then(function (listen) {
      var ausOne = {};
      listen[0].forEach(function (e) { ausOne[e.handle] = true; });
      var ohneOne = function (e) { return !ausOne[e.handle]; };

      listen[0].forEach(function (e) {
        e.kind = 'one';
        e.arme = Number(e.monitors) || 0;
      });

      var gesamt = reihenFuellen(block, pruefung, {
        one: listen[0],
        tisch: listen[1].filter(ohneOne),
        wand: listen[2].filter(ohneOne)
      }, false);

      if (!gesamt) {
        if (gestoert) stoerungSpaeter(block);
        else verstecken(block);
        return;
      }

      if (gestoert) stoerungSpaeter(block, true);
    });
  }

  function aufbauen(block) {
    var pruefung = document.querySelector('[data-fck]');
    if (!pruefung || !pruefung.__fckApi) { block.hidden = true; return; }

    bedienen(block);
    wegRichten(block);
    adapterpreisZeigen(block);
    knopfSetzen(block);

    var gross = block.getAttribute('data-sku-variante') === 'gross';

    if (lage === 'sackgasse') { zuruecksetzen(block); block.hidden = true; return; }
    if (lage === 'misch' && !gross) {
      var marke = block.querySelector('[data-sku-marke]');
      if (marke) marke.hidden = true;

      if (!zustand(block).vomNutzer) modusSetzen(block, 'adapter');
      var weg = block.querySelector('[data-sku-weiterweg]');
      if (weg) weg.hidden = true;
      block.querySelectorAll('[data-sku-spur], [data-sku-schalter], [data-sku-info], [data-lw-paar], [data-lw-mehr]')
        .forEach(function (el) { el.hidden = true; });
      block.hidden = false;

      bedienen(block);
      adapterpreisZeigen(block);
      altLaden(block, function () {
        korbLaden(function () {
          zuordnungZeigen(block);
          adapterpreisZeigen(block);
          preisZeigen(block);
          knopfSetzen(block);
        });
      });
      knopfSetzen(block);
      return;
    }
    wegVerstecken(block);
    offenZeigen(block, gross && lage === 'misch');

    stoerungAbsagen(block);
    var kasten = block.querySelector('[data-sku-stoerung]');
    if (kasten) kasten.hidden = true;

    var refs = auswahlLesen();

    if (gross && lage === 'misch' && refs && offeneRefs.length) {
      var uebrig = refs.filter(function (r) { return offeneRefs.indexOf(String(r)) < 0; });
      refs = uebrig.length ? uebrig : refs;
    }

    if (!refs) {
      vorabZeigen(block, pruefung, !!(window.EngineStatus && window.EngineStatus.gestoert()));
      return;
    }

    if (lage === 'normal' && !zustand(block).vomNutzer) {
      var bedient = !monitore.length || monitore.some(function (m) {
        return m && m.stufe !== 'warn' && m.stufe !== 'neutral' && m.stufe !== 'rec';
      });
      modusSetzen(block, bedient ? 'setup' : 'adapter');
    }

    var proxy = proxyVon(block);

    Promise.all([holen(proxy, refs, ARTEN.tisch), holen(proxy, refs, ARTEN.wand)])
      .then(function (antworten) {
        if (antworten[0] === null || antworten[1] === null) {
          vorabZeigen(block, pruefung, true);
          return;
        }

        var gesamt = reihenFuellen(block, pruefung, {
          one: antworten[0].filter(istOne),
          tisch: nachEmpfehlung(antworten[0].filter(function (e) { return !istOne(e); })),
          wand: nachEmpfehlung(antworten[1])
        }, true);

        if (!gesamt) verstecken(block);
      });
  }

  function stoerungSpaeter(block, nebenSortiment) {
    stoerungAbsagen(block);
    block.__lwStoerung = setTimeout(function () {
      block.__lwStoerung = null;
      stoerungZeigen(block, nebenSortiment);
    }, 900);
  }

  function stoerungAbsagen(block) {
    if (block.__lwStoerung) { clearTimeout(block.__lwStoerung); block.__lwStoerung = null; }
  }

  function stoerungZeigen(block, nebenSortiment) {
    if (!window.EngineStatus) { if (!nebenSortiment) verstecken(block); return; }

    var kasten = block.querySelector('[data-sku-stoerung]');
    if (!kasten) { if (!nebenSortiment) verstecken(block); return; }

    var ziel = (block.getAttribute('data-sku-stoerung-ziel') || '').trim();
    var wort = block.getAttribute('data-sku-stoerung-wort') || 'Alle Halterungen ansehen';

    kasten.innerHTML = window.EngineStatus.hinweisHtml(
      nebenSortiment
        ? skT('stoerung_neben', 'Diese Halterungen sind gerade nicht auf deinen Monitor geprüft.')
        : skT('stoerung_ohne', 'Die Passung lässt sich gerade nicht prüfen.'),
      skT('wa_text', WA_TEXT));

    if (ziel) {
      var a = document.createElement('a');
      a.className = 'sku__ausweich';
      a.href = ziel;
      a.textContent = wort;
      var innen = kasten.querySelector('.eng-aus');
      if (innen) innen.appendChild(a);
    }

    if (lage === 'sackgasse') { zuruecksetzen(block); block.hidden = true; return; }

    kasten.hidden = false;
    block.hidden = false;

    if (nebenSortiment) return;

    var schalter = block.querySelector('[data-sku-schalter]');
    if (schalter) schalter.hidden = true;
    block.querySelectorAll('[data-sku-spur]').forEach(function (spur) { spur.hidden = true; });
    var zahl = block.querySelector('[data-sku-zahl]');
    if (zahl) zahl.textContent = '';
    var marke = block.querySelector('[data-sku-marke]');
    if (marke) marke.hidden = true;
  }

  function tischzeileZeigen(block) {
    var tsa = block.querySelector('[data-tsa]');
    if (!tsa) return;
    var vorhanden = block.__lwGruppen || [];
    var tischDa = vorhanden.indexOf('one') > -1 || vorhanden.indexOf('tisch') > -1;
    var reiter = block.querySelector('[data-sku-tab][aria-selected="true"]');
    var wand = reiter && reiter.getAttribute('data-sku-tab') === 'wand';
    var nurAdapter = zustand(block).modus === 'adapter';

    tsa.hidden = nurAdapter || !!wand || lage === 'misch';
  }

  function umschalten(block, gruppe) {
    block.querySelectorAll('[data-sku-tab]').forEach(function (t) {
      t.setAttribute('aria-selected', String(t.getAttribute('data-sku-tab') === gruppe));
    });

    var info = block.querySelector('[data-sku-info]');
    if (info) { info.dataset.lwDa = '1'; info.hidden = gruppe !== 'one'; }
    block.querySelectorAll('[data-sku-spur]').forEach(function (sp) {
      sp.hidden = sp.getAttribute('data-sku-spur') !== gruppe;
    });
    tischzeileZeigen(block);
    pfeileNachziehen(block);
  }

  function pfeileNachziehen(block) {
    block.querySelectorAll('[data-sku-spur]').forEach(function (spur) {
      if (spur.hidden) return;
      var reihe = spur.querySelector('[data-sku-reihe]');
      var zur = spur.querySelector('[data-sku-pfeil="-1"]');
      var vor = spur.querySelector('[data-sku-pfeil="1"]');
      if (!reihe || !zur || !vor) return;
      var rest = reihe.scrollWidth - reihe.clientWidth;
      zur.hidden = reihe.scrollLeft <= 2;
      vor.hidden = rest <= 2 || reihe.scrollLeft >= rest - 2;
    });
  }

  function schieben(spur, richtung) {
    var reihe = spur.querySelector('[data-sku-reihe]');
    var karte = reihe && reihe.querySelector('.sku__karte');
    if (!reihe || !karte) return;
    var schritt = karte.getBoundingClientRect().width + 10;
    reihe.scrollBy({ left: schritt * richtung, behavior: 'smooth' });
  }

  document.addEventListener('click', function (e) {
    var infoKnopf = e.target.closest && e.target.closest('[data-sku-info]');
    if (infoKnopf) {
      var dlg = infoKnopf.closest('[data-sku]').querySelector('[data-sku-dlg]');
      if (dlg && dlg.showModal) dlg.showModal();
      return;
    }

    var zu = e.target.closest && e.target.closest('[data-sku-dlg-zu]');
    if (zu) { zu.closest('[data-sku-dlg]').close(); return; }

    if (e.target.hasAttribute && e.target.hasAttribute('data-sku-dlg')) {
      e.target.close();
      return;
    }

    var karte = e.target.closest && e.target.closest('[data-sku] [data-mini-handle]');
    if (karte && e.target.closest('[data-mini-auf]')) {
      e.preventDefault();

      var wurzel = karte.closest('[data-sku]');
      var geprueft = wurzel && wurzel.getAttribute('data-sku-geprueft') === 'ja';

      document.dispatchEvent(new CustomEvent('3idee:mini-pdp', {
        bubbles: true,
        cancelable: true,
        detail: { handle: karte.getAttribute('data-mini-handle'), gepruft: geprueft }
      }));
      return;
    }

    var tab = e.target.closest && e.target.closest('[data-sku-tab]');
    if (tab) {
      var block = tab.closest('[data-sku]');
      if (block) umschalten(block, tab.getAttribute('data-sku-tab'));
      return;
    }

    var pfeil = e.target.closest && e.target.closest('[data-sku-pfeil]');
    if (pfeil) {
      schieben(pfeil.closest('[data-sku-spur]'), Number(pfeil.getAttribute('data-sku-pfeil')));
    }
  });

  document.addEventListener('scroll', function (e) {
    var reihe = e.target;
    if (!reihe || !reihe.getAttribute || !reihe.hasAttribute('data-sku-reihe')) return;
    var block = reihe.closest('[data-sku]');
    if (block) pfeileNachziehen(block);
  }, true);

  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-sku]').forEach(pfeileNachziehen);
  });

  function verstecken(block) {
    if (lage === 'misch') { wegZeigen(block); return; }
    zuruecksetzen(block);
    block.hidden = true;
  }

  function wegRichten(block) {
    var knopf = block.querySelector('[data-sku-weiterweg-knopf]');
    if (!knopf) return;
    knopf.href = wegZiel(block);
    var wortZiel = knopf.querySelector('[data-sku-weiterweg-wort-ziel]') || knopf;
    wortZiel.textContent = block.getAttribute('data-sku-weiterweg-wort')
      || 'Setup komplettieren';
  }

  function wegZeigen(block) {
    wegRichten(block);
    var weg = block.querySelector('[data-sku-weiterweg]');
    if (weg) weg.hidden = true;

    block.classList.add('sku--nur-weg');

    var zahl = block.querySelector('[data-sku-zahl]');
    if (zahl) zahl.textContent = '';

    block.hidden = false;
  }

  function offenZeigen(block, an) {
    var kasten = block.querySelector('[data-sku-offen]');
    if (!kasten) return;
    if (!an || !offeneNamen.length) { kasten.hidden = true; return; }
    var namen = block.querySelector('[data-sku-offen-namen]');
    var knopf = block.querySelector('[data-sku-offen-knopf]');
    if (namen) {
      namen.textContent = offeneNamen.length === 1
        ? offeneNamen[0]
        : skT('liste_und', '{liste} und {letzter}', {
            liste: offeneNamen.slice(0, -1).join(', '),
            letzter: offeneNamen[offeneNamen.length - 1]
          });
    }
    if (knopf) {
      knopf.href = wegZiel(block, 'data-sku-offen-ziel');
    }
    kasten.hidden = false;
  }

  function wegVerstecken(block) {
    var weg = block.querySelector('[data-sku-weiterweg]');
    if (weg) weg.hidden = true;
    block.classList.remove('sku--nur-weg');
  }


  function zustand(block) {
    if (!block.__lw) {
      block.__lw = { modus: 'setup', handle: null, gestartet: false, urText: '' };
    }
    return block.__lw;
  }

  function adapterDaten(block) {
    if (block.__lwAdapter === undefined) {
      var el = block.querySelector('script[data-lw-adapter]');
      try { block.__lwAdapter = el ? JSON.parse(el.textContent) : null; }
      catch (e) { block.__lwAdapter = null; }
    }
    return block.__lwAdapter;
  }

  function kaufform() {
    var alle = document.querySelectorAll('form[data-type="add-to-cart-form"]');
    for (var i = 0; i < alle.length; i++) {
      if (!alle[i].closest('dialog')) return alle[i];
    }
    return null;
  }
  function kaufknopf() {
    var f = kaufform();
    return f ? f.querySelector('button[type="submit"]') : null;
  }
  function mengenfeld() {
    var f = kaufform();
    return f ? f.querySelector('input[name="quantity"]') : null;
  }

  function mengeVorbelegen(block, stueck) {
    var mf = mengenfeld();
    if (!mf) return;
    if (block.__lwMenge != null && String(mf.value) !== String(block.__lwMenge)) return;
    block.__lwMenge = stueck;
    if (String(mf.value) === String(stueck)) return;
    mf.value = stueck;
    var form = mf.closest('product-form-component');
    if (form) form.setAttribute('data-quantity-default', stueck);
  }

  function adapterVariante(block) {
    var d = adapterDaten(block);
    if (!d || !d.varianten || !d.varianten.length) return null;
    var feld = kaufform() && kaufform().querySelector('input[name="id"]');
    var id = feld ? Number(feld.value) : 0;
    for (var i = 0; i < d.varianten.length; i++) {
      if (d.varianten[i].id === id) return d.varianten[i];
    }
    return d.varianten[0];
  }

  function adapterAnzahl() {
    if (monitore.length) {
      var n = 0;
      monitore.forEach(function (m) {
        if (m && m.stufe !== 'warn' && m.stufe !== 'neutral' && m.stufe !== 'rec') {
          n += (Number(m.anzahl) || 1);
        }
      });
      return n;
    }
    var a = auswahlLesen();
    return (a && a.length) ? a.length : 1;
  }

  function alternativHandles() {
    var raus = [];
    monitore.forEach(function (m) {
      if (!m || m.stufe !== 'warn') return;
      var h = (m.alternativen || [])[0];
      if (h && raus.indexOf(h) < 0) raus.push(h);
    });
    return raus;
  }

  function vorteilCent(block) {
    return (Number(block.getAttribute('data-sku-bundle')) || 0) * 100;
  }

  function vorteilCentStufe(block, stufe) {
    var attr = stufe === 'flexi' ? 'data-sku-bundle-flexi'
      : stufe === 'flexi_hoch' ? 'data-sku-bundle-flexi-hoch' : 'data-sku-bundle';
    return (Number(block.getAttribute(attr)) || 0) * 100;
  }
  function rabattCent(rabatt, betrag) {
    if (!rabatt || !(Number(rabatt.wert) > 0)) return 0;
    return rabatt.art === 'prozent'
      ? Math.round(betrag * Number(rabatt.wert) / 100)
      : Math.round(Number(rabatt.wert) * 100);
  }
  function eigenRabatt(block) {
    try { return JSON.parse(block.getAttribute('data-lw-rabatt') || 'null'); }
    catch (e) { return null; }
  }
  function teilRabatt(block, t) {
    if (!t) return null;
    if (t.eigen) return eigenRabatt(block);
    var d = t.handle && altDaten[t.handle];
    return (d && d.rabatt) || null;
  }
  function etikett(text, aktion) {
    return '<span class="vorteil-etikett' + (aktion ? ' vorteil-etikett--aktion' : '') + '">'
      + esc(text) + '</span>';
  }
  function euroText(block, cent) {
    return (cent % 100 === 0) ? (cent / 100) + '\u00a0\u20ac' : geld(block, cent);
  }
  function prozentText(r) {
    return r.art === 'prozent'
      ? '\u2212' + Math.round(Number(r.wert)) + '\u00a0%'
      : '\u2212' + String(r.wert).replace('.', ',') + '\u00a0\u20ac';
  }

  function vorteileZeigen(block, r) {
    var beste = block.querySelector('[data-lw-beste]');
    if (beste) beste.hidden = (lage !== 'normal');
    var ziel = block.querySelector('[data-lw-vorteile]');
    if (!ziel) return;
    var proPaar = Math.max(vorteilCentStufe(block, 'one'), vorteilCentStufe(block, 'flexi'),
      vorteilCentStufe(block, 'flexi_hoch'));
    var adapter = 0;
    gewaehlteTeile(block).forEach(function (t) {
      if (t.art === 'ADAPTER') adapter += (Number(t.anzahl) || 1);
    });
    var betrag = proPaar * Math.max(1, adapter);
    var vorlage = block.getAttribute('data-lw-wort-bis') || '';
    if (lage !== 'normal' || !betrag || !vorlage) { ziel.innerHTML = ''; ziel.hidden = true; return; }
    var text = vorlage.replace('%b', euroText(block, betrag))
      .replace('%t', block.getAttribute('data-sku-bundle-titel') || '').trim();
    ziel.innerHTML = '<span class="vorteil-etikett vorteil-etikett--kontur">' + esc(text) + '</span>';
    ziel.hidden = false;
  }

  function geld(block, cent) {
    try {
      return formatMoney(cent, block.getAttribute('data-lw-format') || '',
                         block.getAttribute('data-lw-waehrung') || '');
    } catch (e) {
      return (cent / 100).toFixed(2);
    }
  }

  function halterungsVarianten(d) {
    return ((d && d.varianten) || []).filter(function (v) { return v.kaufbar; });
  }

  function zeilenVariante(d) {
    var kaufbar = halterungsVarianten(d);
    if (kaufbar.length) return { v: kaufbar[0], fehlt: false };
    var alle = (d && d.varianten) || [];
    if (alle.length) return { v: alle[0], fehlt: true };
    return null;
  }

  var altDaten = {};
  var altVariante = {};
  function altLaden(block, fertig) {
    var pruefung = document.querySelector('[data-fck]');
    if (!pruefung || !pruefung.__fckApi || !pruefung.__fckApi.daten) { fertig(); return; }
    var offen = alternativHandles().filter(function (h) { return !altDaten[h]; });
    if (!offen.length) { fertig(); return; }
    Promise.all(offen.map(function (h) {
      return pruefung.__fckApi.daten(h).then(function (d) { altDaten[h] = d; }).catch(function () {});
    })).then(fertig);
  }

  function altPosten() {
    var raus = [];
    alternativHandles().forEach(function (h) {
      var d = altDaten[h];
      var v = halterungsVarianten(d)[0];
      if (v) raus.push({ handle: h, variante: v, titel: (d && d.titel) || '', bild: (d && d.bild) || '' });
    });
    return raus;
  }

  var imKorb = null;
  var korbAnstoss = null;
  document.addEventListener('shopify:cart:lines-update', function () {
    clearTimeout(korbAnstoss);
    korbAnstoss = setTimeout(function () {
      imKorb = null;
      korbLaden(function () {
        document.querySelectorAll('[data-sku]').forEach(function (block) {
          try {
            zuordnungZeigen(block);
            adapterpreisZeigen(block);
            preisZeigen(block);
            summeZeigen(block);
            knopfSetzen(block);
          } catch (e) {
            if (window.console) console.error('Loesungswahl: Warenkorb', e);
          }
        });
      });
    }, 120);
  });

  function korbLaden(fertig) {
    if (imKorb) { fertig(); return; }
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (k) {
        imKorb = {};
        (k.items || []).forEach(function (i) { imKorb[i.variant_id] = i.quantity || 0; });
        fertig();
      })
      .catch(function () { imKorb = {}; fertig(); });
  }

  function teilName(titel, monitor) {
    var kurz = String(titel || '').replace(/\s*\([^)]*\)\s*/g, ' ').trim();
    if (!monitor) return kurz;
    var muster = skT('teil_fuer', '@TEIL@ für @GERAETE@');
    var trenner = muster.split('@TEIL@').pop().split('@GERAETE@')[0];
    var m = kurz.match(/^(.*?)\s+für\s+/i);
    if (m) kurz = m[1];
    else if (trenner.trim()) {
      var pos = kurz.toLowerCase().indexOf(trenner.toLowerCase());
      if (pos > 0) kurz = kurz.slice(0, pos);
    }
    return muster.replace('@TEIL@', kurz.trim()).replace('@GERAETE@', monitor);
  }

  var plattenUrteil = null;
  var plattenDaten = null;
  var plattenLauf = 0;

  var adapterUrteil = null;
  var adapterDatenP = null;
  var adapterStueck = 1;
  var bolzenUrteil = null;
  var bolzenDaten = null;
  var bolzenStueck = 1;

  function bolzenAusMonitoren() {
    var RANG = { REQUIRED: 3, RECOMMENDED: 2, OPTIONAL: 1 };
    var beste = null, stueck = 0;
    (monitore || []).forEach(function (m) {
      if (!m || m.stufe === 'rec') return;
      var eintrag = ((m.zubehoer || [])[0]) || null;
      if (!eintrag || !eintrag.handle) return;
      stueck += Number(m.anzahl) || 1;
      if (!beste || (RANG[eintrag.stufe] || 0) > (RANG[beste.stufe] || 0)) beste = eintrag;
    });
    return { urteil: beste, stueck: stueck || 1 };
  }

  function platteBewerten(block, fertig) {
    fertig = fertig || function () {};
    var lauf = ++plattenLauf;

    function fertigMit(urteil, daten, aUrteil, aDaten, aStueck, bUrteil, bDaten, bStueck) {
      if (lauf !== plattenLauf) return;
      plattenUrteil = urteil || null;
      plattenDaten = daten || null;
      adapterUrteil = aUrteil || null;
      adapterDatenP = aDaten || null;
      adapterStueck = aStueck || 1;
      bolzenUrteil = bUrteil || null;
      bolzenDaten = bDaten || null;
      bolzenStueck = bStueck || 1;
      fertig();
    }
    function leer() { fertigMit(null, null, null, null, 1, null, null, 1); }

    if (typeof window.Verstaerkung === 'undefined') { leer(); return; }

    var z = zustand(block);
    var zeile = z.zeile || block.querySelector('.sku__karte--an');
    var kg = zeile ? parseFloat(zeile.getAttribute('data-lw-kg')) : NaN;
    var mountSku = zeile ? (zeile.getAttribute('data-lw-sku') || '') : '';
    var platteSku = zeile ? (zeile.getAttribute('data-lw-platte-sku') || '') : '';
    var platteStueck = zeile ? (Number(zeile.getAttribute('data-lw-platte-stueck')) || 1) : 1;
    var tisch = tischLesen();
    var refs = auswahlLesen() || [];

    if ((!kg || !isFinite(kg)) && !(tisch && tisch.art) && !platteSku) { leer(); return; }

    var proxy = proxyVon(block);
    var setupKg = zeile ? parseFloat(zeile.getAttribute('data-lw-setup-kg')) : NaN;
    var gewicht = (setupKg && isFinite(setupKg))
      ? Promise.resolve(setupKg)
      : (kg && isFinite(kg) && refs.length)
        ? window.Verstaerkung.monitorGewicht(proxy, refs).then(function (mKg) { return mKg + kg; })
        : Promise.resolve(null);

    var pruefung = document.querySelector('[data-fck]');
    var holeDaten = (pruefung && pruefung.__fckApi && pruefung.__fckApi.daten)
      ? pruefung.__fckApi.daten : null;

    function brauchbar(u) {
      return u && u.handle && u.imShop !== false
             && (u.stufe === 'REQUIRED' || u.stufe === 'RECOMMENDED');
    }
    function laden(u) {
      if (!brauchbar(u) || !holeDaten) return Promise.resolve(null);
      return holeDaten(u.handle).catch(function () { return null; });
    }

    gewicht.then(function (gesamt) {
      if (gesamt && zeile) merkeGewicht(gesamt, zeile.getAttribute('data-mini-handle'));

      return window.Verstaerkung.pruefe({
        proxy: proxy,
        art: (tisch && tisch.art) || '',
        kg: gesamt,
        mountSku: mountSku,
        plateSku: platteSku
      });
    }).then(function (paket) {
      if (!paket) { leer(); return; }
      var uTisch = paket.TABLE_REINFORCEMENT;
      var uPlatte = paket.PLATE;
      var bolzen = bolzenAusMonitoren();
      var uBolzen = bolzen.urteil;
      return Promise.all([laden(uTisch), laden(uPlatte), laden(uBolzen)]).then(function (d) {
        fertigMit(d[0] ? uTisch : null, d[0],
                  d[1] ? uPlatte : null, d[1], platteStueck,
                  d[2] ? uBolzen : null, d[2], bolzen.stueck);
      });
    }).catch(function () { leer(); });
  }

  function merkeGewicht(kg, handle) {
    try {
      var alt = JSON.parse(localStorage.getItem('3idee_auswahl') || 'null') || {};
      alt.tischKg = { kg: Math.round(kg * 100) / 100, mount: handle || '' };
      localStorage.setItem('3idee_auswahl', JSON.stringify(alt));
    } catch (e) {}
  }

  function adapterplattenTeil(block) {
    if (!adapterUrteil || !adapterDatenP) return null;
    if (zustand(block).modus !== 'setup') return null;
    var vw = zeilenVariante(adapterDatenP);
    if (!vw) return null;
    var v = vw.v;
    return {
      monitor: '', handle: adapterUrteil.handle, art: 'PLATE',
      nichtLieferbar: vw.fehlt,
      wiederAb: (adapterDatenP && adapterDatenP.lieferbar_ab) || '', mto: !!(adapterDatenP && adapterDatenP.mto),
      titel: (adapterDatenP.titel || adapterUrteil.name || '').split('|')[0].trim(),
      bild: adapterDatenP.bild || adapterUrteil.bild || '',
      betrag: v.betrag, id: v.id, anzahl: adapterStueck, eigen: false,
      adapterplatte: true, stufe: adapterUrteil.stufe, grund: adapterUrteil.text || '',
      aus: vw.fehlt, standardAus: vw.fehlt
    };
  }

  function plattenTeil(block) {
    if (!plattenUrteil || !plattenDaten) return null;
    if (zustand(block).modus !== 'setup') return null;
    var vw = zeilenVariante(plattenDaten);
    if (!vw) return null;
    var v = vw.v;
    var pflicht = plattenUrteil.stufe === 'REQUIRED';
    return {
      monitor: '', handle: plattenUrteil.handle, art: 'TABLE_REINFORCEMENT',
      wiederAb: (plattenDaten && plattenDaten.lieferbar_ab) || '', mto: !!(plattenDaten && plattenDaten.mto),
      titel: (plattenDaten.titel || plattenUrteil.name || '').split('|')[0].trim(),
      bild: plattenDaten.bild || plattenUrteil.bild || '',
      betrag: v.betrag, id: v.id, anzahl: 1, eigen: false,
      platte: true, stufe: plattenUrteil.stufe, grund: plattenUrteil.text || '',
      nichtLieferbar: vw.fehlt,
      aus: !pflicht || vw.fehlt, standardAus: !pflicht || vw.fehlt
    };
  }

  function bolzenTeil(block) {
    if (!bolzenUrteil || !bolzenDaten) return null;
    if (zustand(block).modus !== 'setup') return null;
    var vw = zeilenVariante(bolzenDaten);
    if (!vw) return null;
    var v = vw.v;
    var pflicht = bolzenUrteil.stufe === 'REQUIRED';
    return {
      monitor: '', handle: bolzenUrteil.handle, art: 'BOLT_SET',
      wiederAb: (bolzenDaten && bolzenDaten.lieferbar_ab) || '', mto: !!(bolzenDaten && bolzenDaten.mto),
      titel: (bolzenDaten.titel || bolzenUrteil.name || '').split('|')[0].trim(),
      bild: bolzenDaten.bild || bolzenUrteil.bild || '',
      betrag: v.betrag, id: v.id, anzahl: bolzenStueck, eigen: false,
      stufe: bolzenUrteil.stufe, grund: bolzenUrteil.text || '',
      nichtLieferbar: vw.fehlt,
      aus: !pflicht || vw.fehlt, standardAus: !pflicht || vw.fehlt
    };
  }

  function zuordnung(block) {
    var av = adapterVariante(block);
    var d = adapterDaten(block);
    if (!av) return [];
    var eigenName = ((d && d.titel) || 'Adapter').replace(/\s*\([^)]*\)\s*/g, ' ').trim();
    var raus = [];
    var luecke = false;

    if (!monitore.length) {
      raus.push({ monitor: '', titel: eigenName, betrag: av.betrag, id: av.id,
                  handle: '', art: 'ADAPTER', bild: (d && d.bild) || '',
                  wiederAb: (d && d.lieferbar_ab) || '', mto: !!(d && d.mto),
                  anzahl: adapterAnzahl(), eigen: true });
      return raus;
    }

    var ohneBedarf = [];

    monitore.forEach(function (m) {
      if (!m || m.stufe === 'rec') return;
      if (m.stufe === 'neutral') { ohneBedarf.push(m.name || ''); return; }
      var stueck = Number(m.anzahl) || 1;
      if (m.stufe === 'warn') {
        var h = (m.alternativen || [])[0];
        var ad = h && altDaten[h];
        var kaufbar = halterungsVarianten(ad);
        var av2 = null;
        if (altVariante[h]) {
          kaufbar.forEach(function (v) { if (v.id === altVariante[h]) av2 = v; });
        }
        if (!av2) av2 = kaufbar[0];
        var fehlt = false;
        if (!av2) {
          var alleV = (ad && ad.varianten) || [];
          if (!alleV.length) { luecke = true; return; }
          av2 = alleV[0];
          fehlt = true;
        }
        raus.push({ monitor: m.name || '', handle: h, art: 'ADAPTER',
                    nichtLieferbar: fehlt,
                    wiederAb: (ad && ad.lieferbar_ab) || '', mto: !!(ad && ad.mto),
                    titel: teilName((ad && ad.titel) || '', m.name),
                    bild: (ad && ad.bild) || '',
                    varianten: kaufbar,
                    grund: (m.gruende || {})[h] || '',
                    betrag: av2.betrag, id: av2.id, anzahl: stueck, eigen: false });
      } else {
        raus.push({ monitor: m.name || '', handle: '', art: 'ADAPTER',
                    wiederAb: (d && d.lieferbar_ab) || '', mto: !!(d && d.mto),
                    titel: teilName(eigenName, m.name),
                    bild: (d && d.bild) || '',
                    grund: m.eigenGrund || '',
                    betrag: av.betrag, id: av.id, anzahl: stueck, eigen: true });
      }
    });
    var hatEigen = raus.some(function (t) { return t.eigen; });
    if (!hatEigen) {
      var nurAdapter = zustand(block).modus === 'adapter';


      if (luecke && !nurAdapter) raus.forEach(function (t) { t.aus = true; });

      var nichtsSonst = raus.length === 0;
      var eigenAus = nurAdapter ? !nichtsSonst : !luecke;

      var ohneBedarfZeile = !nurAdapter && !luecke && ohneBedarf.length > 0;
      if (ohneBedarfZeile) eigenAus = true;

      raus.unshift({ monitor: '', titel: eigenName, betrag: av.betrag, id: av.id,
                     handle: '', art: 'ADAPTER', bild: (d && d.bild) || '',
                     wiederAb: (d && d.lieferbar_ab) || '', mto: !!(d && d.mto),
                     anzahl: 1, eigen: true, keinMonitor: true,
                     ohneBedarf: ohneBedarfZeile,
                     aus: eigenAus,
                     standardAus: eigenAus });
    }

    var adapterplatte = adapterplattenTeil(block);
    if (adapterplatte) raus.push(adapterplatte);

    var bolzen = bolzenTeil(block);
    if (bolzen) raus.push(bolzen);

    var platte = plattenTeil(block);
    if (platte) raus.push(platte);

    raus.forEach(function (t) {
      if (imKorb && !t.eigen && imKorb[t.id]) t.imKorb = true;
    });

    var merk = teileMerk(block);
    raus.forEach(function (t) {
      var w = merk[String(t.id)];
      if (w != null) t.aus = (w === '0');
    });

    raus.forEach(function (t) {
      if (t.nichtLieferbar) { t.aus = true; t.standardAus = true; }
    });
    return raus;
  }

  var MONITOR_ZEICHEN =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"'
    + ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
    + '<rect x="2" y="4" width="20" height="13" rx="1.5"/><path d="M9 21h6M12 17v4"/></svg>';

  var platteBeobachter = null;

  function platteAnkuendigen(li) {
    function spielen() {
      li.classList.add('lw__zu-neu');
      setTimeout(function () { li.classList.remove('lw__zu-neu'); }, 2200);
    }
    if (platteBeobachter) { platteBeobachter.disconnect(); platteBeobachter = null; }
    if (!window.IntersectionObserver) { spielen(); return; }
    platteBeobachter = new IntersectionObserver(function (eintraege, beob) {
      eintraege.forEach(function (eintrag) {
        if (!eintrag.isIntersecting) return;
        beob.disconnect();
        platteBeobachter = null;
        spielen();
      });
    }, { threshold: 0.6 });
    platteBeobachter.observe(li);
  }

  function grundFenster(block) {
    return block.getAttribute('data-lw-grundfenster') || '';
  }

  document.addEventListener('click', function (e) {
    var knopf = e.target.closest && e.target.closest('[data-lw-grund]');
    if (!knopf) return;
    var kennung = knopf.getAttribute('data-fenster-auf');
    var dlg = kennung && document.querySelector('[data-fenster="' + kennung + '"]');
    if (!dlg) return;
    var titel = dlg.querySelector('[data-lw-grund-titel]');
    var text = dlg.querySelector('[data-lw-grund-text]');
    if (titel) titel.textContent = knopf.getAttribute('data-lw-grund-name') || '';
    if (text) text.innerHTML = knopf.getAttribute('data-lw-grund') || '';
  }, true);

  function untersatzZeigen(block) {
    var el = block.querySelector('[data-lw-setup-unter]');
    if (!el) return;

    var ohneBedarf = monitore.length > 0
      && monitore.every(function (m) { return m && m.stufe === 'neutral'; })
      && !adapterUrteil && !bolzenUrteil && !plattenUrteil;

    var bedient = !monitore.length || monitore.some(function (m) {
      return m && m.stufe !== 'warn' && m.stufe !== 'neutral' && m.stufe !== 'rec';
    });

    var misch = lage === 'misch';
    var loesbare = monitore.filter(function (m) {
      if (!m || !m.name || m.stufe === 'rec') return false;
      if (misch) return true;
      if (m.stufe === 'warn') return (m.alternativen || []).length > 0;
      return true;
    }).map(function (m) { return m.name; });

    var genannt = [];
    loesbare.forEach(function (n) { if (genannt.indexOf(n) < 0) genannt.push(n); });

    var satz = '';
    if (ohneBedarf) {
      satz = block.getAttribute('data-lw-untersatz-direkt') || '';
    } else if (genannt.length) {
      satz = (block.getAttribute('data-lw-passend-fuer') || '')
               .replace('%s', genannt.join(', '));
    } else if (!bedient && !monitore.every(function (m) { return !m || m.stufe === 'rec'; })) {
      satz = block.getAttribute('data-lw-untersatz-keine') || '';
    }

    var zeigen = !!satz;
    if (zeigen) el.textContent = satz;
    el.hidden = !zeigen;
  }

  function zuordnungZeigen(block) {
    untersatzZeigen(block);
    var z = zustand(block);
    var teile = zuordnung(block);
    var zeigen = teile.length > 1
      || (teile.length === 1 && teile[0].anzahl > 1)
      || (teile.length === 1 && z.modus === 'setup');

    block.querySelectorAll('[data-lw-zuordnung]').forEach(function (l) {
      var kasten = l.closest('[data-lw-wahl]');
      var meiner = kasten && kasten.getAttribute('data-lw-wahl') === z.modus;

      if (meiner && z.modus === 'setup' && lage !== 'normal') meiner = false;
      if (!zeigen || !meiner) { l.hidden = true; return; }

      l.innerHTML = teile.map(function (t, i) {
        var an = t.aus ? '0' : '1';
        var name = t.handle
          ? '<button class="lw__zu-titel" type="button" data-mini-auf'
            + ' data-lw-handle="' + esc(t.handle) + '">' + esc(t.titel) + '</button>'
          : '<span class="lw__zu-titel">' + esc(t.titel) + '</span>';
        var schon = t.imKorb
          ? '<small class="lw__zu-schon">' + esc(skT('im_korb', 'liegt bereits im Warenkorb')) + '</small>' : '';




        var info = '';
        if (t.grund) {
          info = '<button class="fck__vf-i lw__zu-i" type="button"'
               + ' data-fenster-auf="' + esc(grundFenster(block)) + '"'
               + ' data-lw-grund="' + esc(t.grund) + '"'
               + ' data-lw-grund-name="' + esc(t.titel || '') + '"'
               + ' aria-label="' + esc(skT('warum_teil', 'Warum dieses Teil?')) + '">i</button>';
        }

        var eigenBedient = t.eigen && !t.keinMonitor;
        var chipZeigen = t.stufe === 'RECOMMENDED'
          ? !!t.grund
          : (t.eigen ? eigenBedient : !!t.grund);

        var chip = '';
        if (chipZeigen) {
          var empfohlen = t.stufe === 'RECOMMENDED';
          chip = '<span class="lw__zu-zustandzeile">'
               + '<span class="lw__zu-zustand' + (empfohlen ? '' : ' lw__zu-zustand--pflicht') + '">'
               +   esc(block.getAttribute(empfohlen ? 'data-lw-wort-empfohlen' : 'data-lw-wort-erforderlich')
                       || (empfohlen ? 'Empfohlen' : 'Erforderlich'))
               +   info
               + '</span></span>';
          info = '';
        }
        if (t.ohneBedarf) {
          schon = '<small class="lw__zu-schon lw__zu-kein">'
            + esc(block.getAttribute('data-lw-kein-adapter')
                  || 'Für dein Setup nicht nötig')
            + '</small>';
        } else if (t.keinMonitor) {
          schon = '<small class="lw__zu-schon lw__zu-kein">'
            + esc(block.getAttribute('data-lw-kein-monitor')
                  || 'Passt zu keinem deiner Monitore')
            + '</small>';
        }

        var wahl = '';
        if (!t.eigen && (t.varianten || []).length > 1) {
          wahl = '<select class="lw__zu-variante" data-lw-variante="' + esc(t.handle) + '">'
            + t.varianten.map(function (v) {
                var wort = (v.optionen || []).join(' / ') || v.titel || '';
                return '<option value="' + v.id + '"'
                  + (v.id === t.id ? ' selected' : '') + '>' + esc(wort) + '</option>';
              }).join('')
            + '</select>';
        }
        var bild = '<span class="lw__zu-bild' + (t.eigen ? ' lw__zu-bild--eigen' : '') + '">'
          + (t.bild ? '<img src="' + esc(t.bild) + '" alt="" loading="lazy">' : '')
          + '</span>';
        var mal = t.anzahl > 1
          ? '<span class="lw__zu-mal">' + t.anzahl + '×</span>' : '';
        var preis = geld(block, t.betrag)
          + (t.anzahl > 1 ? '<small>/ ' + esc(skT('stueck', 'Stück')) + '</small>' : '');
        return '<li data-lw-teil="' + i + '" data-lw-an="' + an + '"'
          + (t.id ? ' data-lw-id="' + t.id + '"' : '')
          + (t.eigen ? ' data-lw-eigen' : '')
          + (t.platte ? ' data-lw-platte="' + (t.stufe === 'REQUIRED' ? 'pflicht' : 'empfohlen') + '"' : '')
          + (t.adapterplatte ? ' data-lw-adapterplatte' : '')
          + (t.standardAus ? ' data-lw-kein-standard' : '')
          + (t.nichtLieferbar ? ' data-lw-gesperrt' : '') + '>'
          + '<span class="lw__zu-kreis" aria-hidden="true"></span>'
          + bild
          + '<span class="lw__zu-teil">' + mal + name + info + wahl + chip + schon + '</span>'
          + '<span class="lw__zu-preis">' + preis + '</span>'
          + '</li>';
      }).join('');
      l.hidden = false;
    });
    eigenHinweis(block);
    etikettenNachziehen(block);
    vorbehaltWort(block);

    if (!block.__lwGesehen) block.__lwGesehen = {};
    ['data-lw-adapterplatte', 'data-lw-platte'].forEach(function (merkmal) {
      var li = block.querySelector('[data-lw-zuordnung]:not([hidden]) li[' + merkmal + ']');
      if (li && !block.__lwGesehen[merkmal]) platteAnkuendigen(li);
      block.__lwGesehen[merkmal] = !!li;
    });
  }

  function eigenHinweis(block) {
    block.querySelectorAll('[data-lw-zuordnung]:not([hidden]) li[data-lw-teil]')
      .forEach(function (li) {
        if (li.hasAttribute('data-lw-kein-standard')) return;
        if (li.querySelector('.lw__zu-schon:not(.lw__zu-kein)')) return;
        if (li.querySelector('.lw__zu-zustand')) return;
        var aus = li.getAttribute('data-lw-an') === '0';
        var alt = li.querySelector('.lw__zu-hinweis');
        if (!aus) { if (alt) alt.remove(); return; }
        if (alt) return;
        var ziel = li.querySelector('.lw__zu-teil');
        if (!ziel) return;
        var p = document.createElement('small');
        p.className = 'lw__zu-hinweis';
        p.textContent = li.hasAttribute('data-lw-adapterplatte')
          ? (block.getAttribute('data-lw-adapterplatte-satz')
             || 'Wird für die gewählte Halterung benötigt')
          : li.hasAttribute('data-lw-platte')
          ? (block.getAttribute('data-lw-platte-pflicht')
             || 'Für deine Tischplatte erforderlich')
          : li.hasAttribute('data-lw-eigen')
            ? (block.getAttribute('data-lw-eigen-wort')
               || 'Diesen Adapter siehst du dir gerade an')
            : (block.getAttribute('data-lw-fremd-wort')
               || 'Wird für einen Monitor in deinem Setup benötigt');
        ziel.appendChild(p);
      });
  }

  function gewaehlteTeile(block) {
    var teile = zuordnung(block);
    var l = block.querySelector('[data-lw-zuordnung]:not([hidden])');
    if (!l) return teile.filter(function (t) { return !t.aus; });
    return teile.filter(function (t, i) {
      var li = l.querySelector('[data-lw-teil="' + i + '"]');
      return !li || li.getAttribute('data-lw-an') === '1';
    });
  }

  function rechne(block, zeile, hd) {
    var av = adapterVariante(block);
    var hv = halterungsVarianten(hd)[0];
    if (!av || !hv) return null;
    var anzahl = adapterAnzahl();
    var arme = Number(zeile.getAttribute('data-lw-arme')) || 0;
    var one = zeile.getAttribute('data-lw-one') === '1';

    var teile = gewaehlteTeile(block);
    var adapterSumme = 0, adapterGesamt = 0;
    var stueckGesamt = 0;
    teile.forEach(function (t) {
      adapterSumme += t.betrag * t.anzahl;
      stueckGesamt += t.anzahl;
      if (t.art === 'ADAPTER') adapterGesamt += t.anzahl;
    });
    var andere = altPosten();

    var voll = adapterSumme + hv.betrag;
    var stufe = (hd && hd.stufe) || (one ? 'one' : null);
    if (stufe === 'flexi') {
      var flexiAb = Number(block.getAttribute('data-sku-bundle-flexi-ab')) || 0;
      if (flexiAb > 0 && hv.betrag / (arme || 1) >= flexiAb * 100) stufe = 'flexi_hoch';
    }
    var vorteil = stufe ? vorteilCentStufe(block, stufe) * Math.min(adapterGesamt, arme || 1) : 0;
    var rabatte = [];
    var rabatt = rabattCent(hd && hd.rabatt, hv.betrag);
    if (rabatt) rabatte.push(hd.rabatt);
    teile.forEach(function (t) {
      var tr = teilRabatt(block, t);
      var c = rabattCent(tr, t.betrag) * (t.anzahl || 1);
      if (c) { rabatt += c; rabatte.push(tr); }
    });
    return { av: av, hv: hv, anzahl: anzahl, andere: andere, teile: teile,
             adapterGesamt: adapterGesamt, stueckGesamt: stueckGesamt,
             voll: voll, vorteil: vorteil, rabatt: rabatt, rabatte: rabatte, stufe: stufe,
             summe: voll - vorteil - rabatt };
  }

  function setzePreise(block) {
    var pruefung = document.querySelector('[data-fck]');
    if (!pruefung || !pruefung.__fckApi || !pruefung.__fckApi.daten) return;

    var offen = [];
    block.querySelectorAll('[data-mini-handle]').forEach(function (zeile) {
      var handle = zeile.getAttribute('data-mini-handle');
      offen.push(pruefung.__fckApi.daten(handle).then(function (hd) {
        zeile.__lwDaten = hd;
        var r = rechne(block, zeile, hd);
        if (!r) return;
        var p = zeile.querySelector('[data-lw-preis]');
        var st = zeile.querySelector('[data-lw-streich]');
        var kr = rabattCent(hd && hd.rabatt, r.hv.betrag);
        if (p) {
          if (kr) {
            p.innerHTML = '<span class="vorteil-preis' + (hd.rabatt.aktion ? ' vorteil-preis--aktion' : '')
              + '">' + esc(geld(block, r.hv.betrag - kr)) + '</span>';
          } else {
            p.textContent = geld(block, r.hv.betrag);
          }
        }
        if (st) st.textContent = kr ? geld(block, r.hv.betrag) : '';
        var pz = zeile.querySelector('.sku__preiszeile');
        if (pz) pz.classList.toggle('sku__preiszeile--rabatt', !!kr);
        kurzzeileFuellen(zeile, hd);
      }).catch(function () {}));
    });

    Promise.all(offen).then(function () { wahlHerstellen(block); });
  }

  function merkschluessel(block) {
    var d = adapterDaten(block);
    return '3idee_lw_' + ((d && d.titel) || 'adapter');
  }

  function teileSchluessel(block) { return merkschluessel(block) + ':teile'; }

  function teileMerk(block) {
    try { return JSON.parse(sessionStorage.getItem(teileSchluessel(block)) || '{}') || {}; }
    catch (e) { return {}; }
  }

  function teileVergessen(block) {
    try { sessionStorage.removeItem(teileSchluessel(block)); } catch (e) {}
  }

  function teilMerken(block, id, an) {
    if (!id) return;
    try {
      var m = teileMerk(block);
      m[String(id)] = an ? '1' : '0';
      sessionStorage.setItem(teileSchluessel(block), JSON.stringify(m));
    } catch (e) {}
  }

  function wahlHerstellen(block) {
    if (block.hidden || lage !== 'normal') return;

    var z = zustand(block);

    var gemerkt = '';
    try { gemerkt = sessionStorage.getItem(merkschluessel(block)) || ''; } catch (e) {}
    var wuensche = [z.handle, gemerkt, block.getAttribute('data-lw-standard')]
      .map(function (w) { return String(w || '').trim().toLowerCase(); })
      .filter(Boolean);

    var zielGruppe = block.__lwZiel || '';

    var treffer = null, billigsteOne = null, billigstOne = null;
    var billigsteEgal = null, billigstEgal = null;
    block.querySelectorAll('[data-mini-handle]').forEach(function (zeile) {
      if (zielGruppe && !z.vonHand) {
        var g = zeile.closest('[data-sku-reihe]');
        if (g && g.getAttribute('data-sku-reihe') !== zielGruppe) return;
      }
      var hd = zeile.__lwDaten;
      var kennungen = [(zeile.getAttribute('data-mini-handle') || '').toLowerCase()];
      if (hd) {
        kennungen.push(String(hd.sku || '').toLowerCase());
        (hd.varianten || []).forEach(function (v) {
          if (v.sku) kennungen.push(String(v.sku).toLowerCase());
        });
      }
      if (!treffer) {
        for (var i = 0; i < wuensche.length; i++) {
          if (kennungen.indexOf(wuensche[i]) > -1) { treffer = zeile; break; }
        }
      }
      if (!hd) return;
      var v0 = halterungsVarianten(hd)[0];
      if (!v0) return;
      if (zeile.getAttribute('data-lw-one') === '1') {
        if (billigstOne === null || v0.betrag < billigstOne) { billigstOne = v0.betrag; billigsteOne = zeile; }
      }
      if (billigstEgal === null || v0.betrag < billigstEgal) { billigstEgal = v0.betrag; billigsteEgal = zeile; }
    });

    var ziel = treffer || billigsteOne || billigsteEgal;
    if (!ziel) return;

    var gruppenkasten = ziel.closest('[data-sku-reihe]');
    if (gruppenkasten) umschalten(block, gruppenkasten.getAttribute('data-sku-reihe'));

    waehle(block, ziel);
  }

  function einstiegZeigen(block) {
    var el = block.querySelector('[data-sku-zahl]');
    if (el) el.textContent = '';
  }

  function adapterpreisZeigen(block) {
    var el = block.querySelector('[data-lw-adapterpreis]');
    if (!el) return;
    var av = adapterVariante(block);
    if (!av) { el.textContent = ''; return; }

    var teile = zuordnung(block);
    if (teile.length < 2) {
      var er = eigenRabatt(block);
      var ec = rabattCent(er, av.betrag);
      if (ec) {
        el.innerHTML = '<s class="lw__gesamt-alt">' + geld(block, av.betrag) + '</s> '
          + geld(block, av.betrag - ec) + ' '
          + etikett(prozentText(er) + (er.aktion ? '' : ' ' + er.titel), er.aktion);
        return;
      }
      el.textContent = geld(block, av.betrag);
      return;
    }

    var z = zustand(block);
    if (z.modus === 'adapter') {
      var summe = 0;
      gewaehlteTeile(block).forEach(function (t) { summe += t.betrag * t.anzahl; });
      el.textContent = summe ? geld(block, summe) : '';
      return;
    }
    var kleinster = null;
    teile.forEach(function (t) {
      if (t.platte || t.adapterplatte) return;
      if (kleinster === null || t.betrag < kleinster) kleinster = t.betrag;
    });
    var wort = block.getAttribute('data-lw-ab-wort') || 'ab';
    el.textContent = kleinster === null ? '' : wort + ' ' + geld(block, kleinster);
  }

  function waehle(block, zeile) {
    var z = zustand(block);
    block.querySelectorAll('.sku__karte').forEach(function (k) {
      var an = k === zeile;
      k.classList.toggle('sku__karte--an', an);
      k.setAttribute('aria-checked', an ? 'true' : 'false');
    });
    ungepruefetHinweis(block);
    z.handle = zeile ? zeile.getAttribute('data-mini-handle') : null;
    z.zeile = zeile || null;
    try {
      if (z.handle) sessionStorage.setItem(merkschluessel(block), z.handle);
      else sessionStorage.removeItem(merkschluessel(block));
    } catch (e) {}
    paarZeigen(block);
    listeKlappen(block, !!zeile);

    if (zeile) {
      var spur = zeile.parentNode;
      if (spur && spur.scrollLeft) {
        try { spur.scrollTo({ left: 0, behavior: 'auto' }); }
        catch (e) { spur.scrollLeft = 0; }
      }
    }
    preisZeigen(block);
    zuordnungZeigen(block);
    summeZeigen(block);
    einstiegZeigen(block);
    knopfSetzen(block);
    platteBewerten(block, function () {
      zuordnungZeigen(block);
      preisZeigen(block);
      summeZeigen(block);
      knopfSetzen(block);
    });
  }

  function ungepruefetHinweis(block) {
    var z = zustand(block);
    var ungeprueft = block.getAttribute('data-sku-geprueft') !== 'ja';
    var el = block.querySelector('[data-lw-ungeprueft]');
    if (!el) return;

    if (!el.__lwHeim) { el.__lwHeim = el.parentNode; el.__lwVor = el.nextSibling; }

    var teile = zuordnung(block);
    var keinTreffer = !ungeprueft && teile.length === 1 && !!teile[0].keinMonitor;

    var laut = (ungeprueft && (z.modus === 'adapter' || z.beruehrt === true))
            || (keinTreffer && z.modus === 'adapter');

    if (laut && z.modus === 'adapter') {
      var kasten = block.querySelector('[data-lw-wahl="adapter"]');
      var ziel = (kasten && kasten.querySelector('.lw__feld')) || kasten;
      var vor = ziel && ziel.querySelector('[data-lw-zuordnung]');
      if (vor && vor.parentNode !== ziel) vor = null;
      if (ziel && el.parentNode !== ziel) ziel.insertBefore(el, vor || null);
    } else if (el.__lwHeim && el.parentNode !== el.__lwHeim) {
      el.__lwHeim.insertBefore(el, el.__lwVor || null);
    }

    if (el.dataset.lwAus) delete el.dataset.lwAus;

    var satzEl = el.querySelector('.lw__ungeprueft-satz');
    if (satzEl) {
      if (satzEl.__lwUr == null) satzEl.__lwUr = satzEl.textContent.trim();
      satzEl.textContent = keinTreffer
        ? (block.getAttribute('data-lw-kein-monitor') || satzEl.__lwUr)
        : satzEl.__lwUr;
    }

    el.hidden = !laut;
    block.classList.toggle('lw--vorbehalt-laut', laut);
    block.classList.toggle('lw--vorbehalt-keinmonitor', laut && keinTreffer);
    block.classList.toggle('lw--vorbehalt-leise', laut && keinTreffer);
  }

  function vorbehaltWort(block) {
    var z = zustand(block);
    var ungeprueft = !monitore.length;

    var adapter = block.querySelector('[data-lw-adapter-marke]');
    if (adapter) {
      if (ungeprueft && !adapter.innerHTML) {
        adapter.innerHTML = '<span class="sku__ungeprueft">'
          + esc(block.getAttribute('data-lw-wort-ungeprueft') || 'ungeprüft')
          + '</span>';
      }
      adapter.hidden = !ungeprueft || z.modus === 'adapter';
    }

    var hatKaesten = !!block.querySelector('[data-lw-wahl]');
    var setup = block.querySelector('[data-sku-marke]');
    if (setup) {
      var kopf = block.querySelector('.lw__feldkopf');
      var taste = block.querySelector('[data-lw-wahl="setup"] > .lw__zeile');
      var ort = ungeprueft ? taste : kopf;
      if (ort && setup.parentNode !== ort) ort.appendChild(setup);
    }
    if (setup) {
      setup.hidden = !setup.innerHTML
        || (ungeprueft && (!hatKaesten || z.modus === 'setup'));
    }
  }

  function listeKlappen(block, zu) {
    var schalter = block.querySelector('[data-sku-schalter]');
    if (schalter) {
      var reiter = 0;
      block.querySelectorAll('[data-sku-tab]').forEach(function (t) { if (!t.hidden) reiter++; });
      schalter.hidden = reiter < 2;
    }
    var info = block.querySelector('[data-sku-info]');
    if (info) info.hidden = aktiveGruppe(block) !== 'one' || !info.dataset.lwDa;
    vorbehaltWort(block);
  }

  function aktiveGruppe(block) {
    var an = block.querySelector('[data-sku-tab][aria-selected="true"]');
    return an ? an.getAttribute('data-sku-tab') : 'one';
  }

  function paarZeigen() {}

  function kaufzonen(block) {
    var raus = [];
    var rechts = document.querySelector('.product-buybox');
    if (rechts) raus.push(rechts);
    var mitte = block.closest('.product-details');
    if (mitte && raus.indexOf(mitte) < 0) raus.push(mitte);
    return raus;
  }

  function preisTraeger(block) {
    var raus = [];
    kaufzonen(block).forEach(function (spalte) {
      spalte.querySelectorAll('[ref="priceContainer"]').forEach(function (t) {
        if (raus.indexOf(t) < 0) raus.push(t);
      });
    });
    document.querySelectorAll('.sticky-add-to-cart [ref="priceContainer"], sticky-add-to-cart [ref="priceContainer"]')
      .forEach(function (t) { if (raus.indexOf(t) < 0) raus.push(t); });
    return raus;
  }

  function preisZuruecksetzen(block) {
    preisTraeger(block).forEach(function (traeger) {
      traeger.style.display = '';
      traeger.classList.remove('lw--eigenpreis');
      var eigen = traeger.querySelector(':scope > .lw__gesamt');
      if (eigen) eigen.hidden = true;
    });
  }

  function zuruecksetzen(block) {
    preisZuruecksetzen(block);
    var knopf = kaufknopf();
    var z = zustand(block);
    if (knopf) {
      var ur = z.urText || knopfUrtext(knopf);
      if (ur) knopfText(knopf, ur);
      knopf.disabled = knopf.hasAttribute('data-ausverkauft');
      knopf.classList.remove('lw__cta--zweit');
    }
    flugSetzen(true);
    var mf = mengenfeld();
    var mtraeger = mf ? mf.closest('quantity-selector-component, .quantity-selector, [class*="quantity"]') : null;
    if (mtraeger) mtraeger.classList.remove('lw--weg');
    kaufzonen(block).forEach(function (spalte) { spalte.classList.remove('lw--nurweg'); });
    document.querySelectorAll('.lw--kaufbox-weg')
      .forEach(function (el) { el.classList.remove('lw--kaufbox-weg'); });
    var wegKasten = block.querySelector('[data-sku-weiterweg]');
    if (wegKasten) wegKasten.hidden = true;
  }

  function uspMelden(block) {
    var z = zustand(block);
    var gruppe = null;
    if (!block.hidden && lage === 'normal' && z.modus === 'setup' && z.handle && z.zeile) {
      gruppe = z.zeile.getAttribute('data-lw-one') === '1' ? 'one' : 'mount';
    }
    if (block.__uspGruppe === gruppe) return;
    block.__uspGruppe = gruppe;
    document.dispatchEvent(new CustomEvent('3idee:usp-gruppe', { detail: { gruppe: gruppe } }));
  }

  function preisZeigen(block) {
    uspMelden(block);
    if (block.hidden) { preisZuruecksetzen(block); return; }
    var z = zustand(block);
    var r = null;
    if (z.modus === 'adapter') {
      var teile = gewaehlteTeile(block);
      var nurEigen = teile.length > 0 && teile.every(function (t) { return t.eigen; });
      if (teile.length && !nurEigen) {
        var summe = 0;
        teile.forEach(function (t) { summe += t.betrag * t.anzahl; });
        r = { summe: summe, voll: summe, vorteil: 0 };
      }
    } else if (lage === 'normal' && z.handle && z.zeile && z.zeile.__lwDaten) {
      r = rechne(block, z.zeile, z.zeile.__lwDaten);
    }
    vorteileZeigen(block, r);

    preisTraeger(block).forEach(function (traeger) {
      if (!traeger.parentNode) return;

      var eigen = traeger.querySelector(':scope > .lw__gesamt');
      if (!eigen) {
        eigen = document.createElement('div');
        eigen.className = 'lw__gesamt';
        eigen.hidden = true;
        traeger.appendChild(eigen);
      }

      if (!r) {
        eigen.hidden = true;
        traeger.classList.remove('lw--eigenpreis');
        traeger.style.display = '';
        document.dispatchEvent(new CustomEvent('3idee:auswahlpreis',
          { detail: { cent: 0 } }));
        return;
      }
      var gespart = (r.vorteil || 0) + (r.rabatt || 0);
      var sparWort = (block.getAttribute('data-lw-wort-sparst') || 'Du sparst %s')
        .replace('%s', geld(block, gespart));
      eigen.innerHTML = (gespart
          ? '<s class="lw__gesamt-alt">' + geld(block, r.voll) + '</s>' : '')
        + '<span class="price">' + geld(block, r.summe) + '</span>'
        + (gespart ? '<span class="vorteil-etikett vorteil-etikett--sparst">' + esc(sparWort) + '</span>' : '');
      eigen.hidden = false;

      document.dispatchEvent(new CustomEvent('3idee:auswahlpreis',
        { detail: { cent: r.summe } }));
      traeger.classList.add('lw--eigenpreis');
      traeger.style.display = '';
    });
  }

  function summeZeigen(block) {
    var liste = block.querySelector('[data-lw-summe]');
    if (liste) liste.hidden = true;
  }

  function lagerzeile() {
    var alle = [].slice.call(document.querySelectorAll('.lgz'));
    for (var i = 0; i < alle.length; i++) {
      if (!alle[i].closest('dialog')) return alle[i];
    }
    return null;
  }

  function alsDatum(text) {
    var m = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec(String(text || '').trim());
    return m ? new Date(+m[3], +m[2] - 1, +m[1]).getTime() : 0;
  }

  function paketTermin(block) {
    var spaet = '';
    function merke(wert) {
      if (wert && alsDatum(wert) > alsDatum(spaet)) spaet = wert;
    }
    gewaehlteTeile(block).forEach(function (t) { merke(t.wiederAb); });

    var z = zustand(block);
    if (z.modus === 'setup' && z.zeile && z.zeile.__lwDaten) {
      merke(z.zeile.__lwDaten.lieferbar_ab);
    }
    return spaet;
  }

  function paketGefertigt(block, eigenGefertigt) {
    var teile = gewaehlteTeile(block);
    var z = zustand(block);
    var halterung = (z.modus === 'setup' && z.zeile && z.zeile.__lwDaten) ? z.zeile.__lwDaten : null;
    if (!teile.length && !halterung) return null;
    var ja = teile.some(function (t) { return t.eigen ? eigenGefertigt : !!t.mto; });
    if (halterung && halterung.mto) ja = true;
    return ja;
  }

  function terminZeigen(block) {
    var zeile = lagerzeile();
    if (!zeile) return;
    var txt = zeile.querySelector('.lgz__text');
    if (!txt) return;

    if (zeile.__lwUr === undefined) {
      zeile.__lwUr = { text: txt.textContent, klasse: zeile.className };
    }

    var zv = zustand(block);
    var hvor = (zv.modus === 'setup' && zv.zeile && zv.zeile.__lwDaten && zv.zeile.__lwDaten.vorbestellung) ? zv.zeile.__lwDaten : null;
    if (hvor) {
      txt.textContent = (block.getAttribute('data-lw-wort-vor') || 'Vorbestellbar')
        + (hvor.liefertermin ? ' – ' + (block.getAttribute('data-lw-wort-lieferbar-ab') || 'Lieferbar ab %s').replace('%s', hvor.liefertermin) : '');
      zeile.className = zeile.__lwUr.klasse.replace(/lgz--\w+/, 'lgz--vor');
      return;
    }

    var termin = paketTermin(block);
    if (!termin) {
      var ur = zeile.__lwUr;
      var urStufe = (/lgz--(\w+)/.exec(ur.klasse) || [])[1] || '';
      var mto = paketGefertigt(block, urStufe === 'mto');
      if ((urStufe === 'lager' || urStufe === 'mto') && mto !== null) {
        var soll = mto ? 'mto' : 'lager';
        if (soll === urStufe) {
          txt.textContent = ur.text;
        } else {
          txt.textContent = mto
            ? (block.getAttribute('data-lw-wort-mto') || 'Wird für dich gefertigt')
            : (block.getAttribute('data-lw-wort-lager') || 'Auf Lager');
        }
        zeile.className = ur.klasse.replace(/lgz--\w+/, 'lgz--' + soll);
        return;
      }
      txt.textContent = ur.text;
      zeile.className = ur.klasse;
      return;
    }
    txt.textContent = (block.getAttribute('data-lw-wort-lieferbar-ab') || 'Lieferbar ab %s')
      .replace('%s', termin);
    zeile.className = zeile.__lwUr.klasse.replace(/lgz--\w+/, 'lgz--ab');
  }

  function fehlendeZeigen(block) {
    var zeile = lagerzeile();
    if (!zeile || !zeile.parentNode) return;

    var el = zeile.parentNode.querySelector(':scope > .lw__fehlt');
    var fehlend = block.hidden
      ? []
      : zuordnung(block).filter(function (t) { return t.nichtLieferbar; });

    if (!fehlend.length) { if (el) el.remove(); return; }
    if (!el) {
      el = document.createElement('p');
      el.className = 'lw__fehlt';
      zeile.parentNode.insertBefore(el, zeile.nextSibling);
    }

    var kopf = fehlend.length === 1
      ? (block.getAttribute('data-lw-fehlt-satz') || '%s ist derzeit nicht lieferbar')
          .replace('%s', fehlend[0].titel || '')
      : (block.getAttribute('data-lw-fehlt-mehrere')
         || '%d Teile deines Setups sind derzeit nicht lieferbar')
          .replace('%d', fehlend.length);

    var pflicht = fehlend.some(function (t) {
      return t.adapterplatte || (t.art === 'ADAPTER' && !!t.monitor)
             || t.stufe === 'REQUIRED';
    });

    var satz = '<span class="lw__fehlt-kopf">' + esc(kopf) + '</span>';
    if (pflicht && zustand(block).modus === 'setup') {
      satz += ' ' + esc(block.getAttribute('data-lw-fehlt-trotzdem') || '');
    }

    var melden = block.getAttribute('data-lw-fehlt-melden') || '';
    if (melden) {
      var wa = '';
      try {
        if (window.EngineStatus && window.EngineStatus.waAdresse) {
          wa = window.EngineStatus.waAdresse(
            (block.getAttribute('data-lw-fehlt-wa') || '') + (fehlend[0].titel || ''));
        }
      } catch (e) {}
      satz += ' ' + (wa
        ? '<a href="' + esc(wa) + '" target="_blank" rel="noopener noreferrer">'
          + esc(melden) + '</a>'
        : esc(melden));
    }
    el.innerHTML = satz;
  }

  function knopfSetzen(block) {
    terminZeigen(block);
    fehlendeZeigen(block);

    var knopf = kaufknopf();
    if (!knopf) return;
    if (block.hidden) { zuruecksetzen(block); return; }
    var z = zustand(block);
    if (!z.urText) z.urText = knopfUrtext(knopf);
    var setupWort = block.querySelector('[data-lw-wahl="setup"] .lw__titel');
    setupWort = setupWort ? setupWort.textContent.trim() : 'Setup komplettieren';

    var text = z.urText, gesperrt = false, zweit = false;
    if (z.modus === 'adapter') {
      var teileA = gewaehlteTeile(block);
      var stueckA = 0;
      teileA.forEach(function (t) { stueckA += t.anzahl; });
      if (teileA.length === 1) {
        mengeVorbelegen(block, teileA[0].anzahl);
        var mf2 = mengenfeld();
        var eingestellt = mf2 ? (parseInt(mf2.value, 10) || 0) : 0;
        if (eingestellt > 0) stueckA = eingestellt;
      }
      if (stueckA > 1) {
        text = (block.getAttribute('data-lw-korb-wort') || '%d Artikel hinzufügen')
          .replace('%d', stueckA);
      } else if (!teileA.length) {
        gesperrt = true;
      }
    }
    if (z.modus === 'setup') {
      if (lage === 'misch') { text = setupWort; zweit = true; }
      else if (!z.handle) { text = setupWort; gesperrt = true; }
      else {
        var r = (z.zeile && z.zeile.__lwDaten) ? rechne(block, z.zeile, z.zeile.__lwDaten) : null;
        var stueck = r ? (r.stueckGesamt + 1) : 2;
        if (stueck < 1) stueck = 1;
        text = (block.getAttribute('data-lw-korb-wort') || '%d Artikel hinzufügen')
          .replace('%d', stueck);
      }
    }
    if (knopf.hasAttribute('data-ausverkauft') && !zweit) {
      var idFeld = kaufform() && kaufform().querySelector('input[name="id"]');
      var eigeneId = idFeld ? Number(idFeld.value) : 0;
      var rAus = (z.modus === 'setup' && z.zeile && z.zeile.__lwDaten) ? rechne(block, z.zeile, z.zeile.__lwDaten) : null;
      var posten = (rAus && rAus.teile) || gewaehlteTeile(block);
      var drin = !posten.length || posten.some(function (t) { return Number(t.id) === eigeneId && t.anzahl > 0; });
      if (drin) { gesperrt = true; text = z.urText || text; }
    }
    knopfText(knopf, text);
    knopf.disabled = gesperrt;
    knopf.classList.toggle('lw__cta--zweit', zweit);

    kaufzonen(block).forEach(function (spalte) { spalte.classList.toggle('lw--nurweg', zweit); });

    var kaufbox = knopf.closest('.group-block');
    if (kaufbox) {
      kaufbox.classList.add('lw--kaufbox');
      kaufbox.classList.toggle('lw--kaufbox-weg', zweit);
    }
    var wegKasten = block.querySelector('[data-sku-weiterweg]');
    if (wegKasten) wegKasten.hidden = !(zweit && lage === 'misch' && auswahlLesen());

    flugSetzen(!zweit);

    var mf = mengenfeld();
    var traeger = mf ? mf.closest('quantity-selector-component, .quantity-selector, [class*="quantity"]') : null;
    if (traeger) traeger.classList.toggle('lw--weg', z.modus !== 'adapter');
  }

  function knopfZiel(knopf) {
    var ziel = null;
    knopf.querySelectorAll('span').forEach(function (sp) {
      if (!ziel && sp.children.length === 0 && (sp.textContent || '').trim()) ziel = sp;
    });
    return ziel;
  }

  function knopfUrtext(knopf) {
    var da = knopf.getAttribute('data-lw-urtext');
    if (da) return da;
    var ziel = knopfZiel(knopf);
    var t = ziel ? (ziel.textContent || '').trim() : (knopf.textContent || '').trim();
    if (t) knopf.setAttribute('data-lw-urtext', t);
    return t;
  }

  function flugSetzen(an) {
    var traeger = document.querySelector('add-to-cart-component[data-add-to-cart-animation]');
    if (!traeger) return;
    if (!traeger.hasAttribute('data-lw-flug-ur')) {
      traeger.setAttribute('data-lw-flug-ur',
        traeger.getAttribute('data-add-to-cart-animation') || 'false');
    }
    traeger.setAttribute('data-add-to-cart-animation',
      an ? (traeger.getAttribute('data-lw-flug-ur') || 'false') : 'false');
  }

  function knopfText(knopf, text) {
    var ziel = knopfZiel(knopf);
    if (ziel) ziel.textContent = text; else knopf.textContent = text;
  }


  function legen(block) {
    var z = zustand(block);
    if (!window.WarenkorbLegen) return;

    var teile = gewaehlteTeile(block);
    var r = null;
    if (z.modus === 'setup') {
      if (!z.handle || !z.zeile || !z.zeile.__lwDaten) return;
      r = rechne(block, z.zeile, z.zeile.__lwDaten);
      if (!r) return;
      teile = r.teile || teile;
    }
    var knopf = kaufknopf();
    if (knopf) knopf.disabled = true;

    var mfL = mengenfeld();
    var feldMenge = mfL ? (parseInt(mfL.value, 10) || 0) : 0;
    var einzeln = z.modus === 'adapter' && teile && teile.length === 1 && feldMenge > 0;

    var posten = [];
    (teile || []).forEach(function (t) {
      if (!t.id || t.anzahl < 1) return;
      posten.push({ id: t.id, quantity: einzeln ? feldMenge : t.anzahl });
    });
    if (r) posten.push({ id: r.hv.id, quantity: 1 });

    if (!posten.length) { if (knopf) knopf.disabled = false; return; }
    var alt = knopf && knopf.parentNode && knopf.parentNode.querySelector('[data-lw-fehler]');
    if (alt) alt.remove();
    window.WarenkorbLegen(posten, function (ok, grund) {
      if (knopf) knopf.disabled = false;
      if (ok) return;
      knopfText(knopf, skT('nicht_verfuegbar', 'Nicht verfügbar'));
      if (knopf && grund) {
        var zeile = document.createElement('p');
        zeile.setAttribute('data-lw-fehler', '');
        zeile.style.cssText = 'margin:8px 0 0;font-size:13px;line-height:1.4;user-select:text;';
        zeile.textContent = grund;
        knopf.insertAdjacentElement('afterend', zeile);
      }
      try { console.warn('[setup-komplettieren] Warenkorb abgelehnt:', grund, JSON.stringify(posten)); } catch (e) {}
    });
  }

  function monitorFragen() {
    var pruefzone = document.querySelector('[data-fck]');
    if (!pruefzone) return;
    var feld = pruefzone.querySelector('[data-fck-input]');
    var ziel = feld || pruefzone;

    try { ziel.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
    if (!feld) return;

    try { feld.focus({ preventScroll: true }); } catch (e2) {
      try { feld.focus(); } catch (e3) {}
    }

    var rahmen = feld.closest('[data-fck-form]') || feld;
    clearTimeout(rahmen.__lwRing);
    rahmen.classList.remove('fck__feld--gerufen');
    requestAnimationFrame(function () {
      rahmen.classList.add('fck__feld--gerufen');
      rahmen.__lwRing = setTimeout(function () {
        rahmen.classList.remove('fck__feld--gerufen');
      }, 1400);
    });
  }

  function wegZiel(block, merkmal) {
    var ziel = block.getAttribute(merkmal || 'data-sku-weiterweg-ziel')
      || ((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'pages/setup-finder');
    return ziel + (ziel.indexOf('?') > -1 ? '&' : '?') + 'finder=neu&setup=1';
  }

  function themeKauftSelbst(block) {
    if (zustand(block).modus === 'setup') return false;
    var teile = gewaehlteTeile(block);
    if (teile.length !== 1) return false;
    var feld = kaufform() && kaufform().querySelector('input[name="id"]');
    return !!(feld && Number(feld.value) === Number(teile[0].id));
  }

  function knopfAbfangen(block) {
    if (block.__lwAbgefangen) return;
    block.__lwAbgefangen = true;

    document.addEventListener('click', function (e) {
      var knopf = e.target.closest && e.target.closest('button[type="submit"]');
      if (!knopf || !kaufform() || knopf.closest('form') !== kaufform()) return;
      var z = zustand(block);
      if (themeKauftSelbst(block)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (lage === 'misch' && z.modus === 'setup') { window.location.href = wegZiel(block); return; }
      legen(block);
    }, true);

    var f = kaufform();
    if (!f || f.__lwAbgefangen) return;
    f.__lwAbgefangen = true;
    (f.closest('product-form-component') || f).addEventListener('submit', function (e) {
      var z = zustand(block);
      if (themeKauftSelbst(block)) return;
      e.preventDefault();
      e.stopPropagation();
      if (lage === 'misch' && z.modus === 'setup') { window.location.href = wegZiel(block); return; }
      legen(block);
    }, true);
  }

  function modusSetzen(block, modus) {
    var z = zustand(block);
    z.modus = modus;
    block.querySelectorAll('[data-lw-wahl]').forEach(function (k) {
      var an = k.getAttribute('data-lw-wahl') === modus;
      k.classList.toggle('lw__kasten--an', an);
      var eingabe = k.querySelector('.lw__eingabe');
      if (eingabe) eingabe.checked = an;
    });
    var setup = block.querySelector('[data-lw-wahl="setup"]');
    if (setup) {
      setup.querySelectorAll('[data-sku-spur], [data-sku-schalter], [data-sku-info], [data-lw-paar], [data-lw-mehr], [data-sku-weiterweg]')
        .forEach(function (el) { el.dataset.lwAus = (modus === 'setup') ? '' : '1'; });
    }
    block.classList.toggle('lw--adapter', modus === 'adapter');
    tischzeileZeigen(block);
    ungepruefetHinweis(block);
    zuordnungZeigen(block);
    adapterpreisZeigen(block);
    preisZeigen(block);
    zuordnungZeigen(block);
    summeZeigen(block);
    einstiegZeigen(block);
    knopfSetzen(block);
    vorbehaltWort(block);
  }

  function mehrRichten(block) {
    var mehr = block.querySelector('[data-lw-mehr]');
    if (mehr) mehr.hidden = true;
    pfeileNachziehen(block);
  }

  function bedienen(block) {
    var z = zustand(block);
    if (z.gestartet) return;
    z.gestartet = true;

    block.addEventListener('click', function (e) {
      var auf = e.target.closest('[data-mini-auf]');
      if (auf) {
        var traeger = auf.closest('[data-mini-handle]');
        var handle = auf.getAttribute('data-lw-handle')
          || (traeger && traeger.getAttribute('data-mini-handle'));
        var pruefblock = document.querySelector('[data-fck]');
        if (handle && pruefblock && pruefblock.__fckApi && pruefblock.__fckApi.fenster) {
          e.preventDefault();
          e.stopPropagation();
          pruefblock.__fckApi.fenster(handle,
            Number(traeger && traeger.getAttribute('data-mini-anzahl')) || 1, true);
        }
        return;
      }
      if (e.target.closest('[data-fenster-auf]')) return;

      if (e.target.closest('select')) return;

      if (e.target.closest('[data-lw-monitor-frage]')) {
        e.preventDefault();
        monitorFragen();
        return;
      }

      var teilZeile = e.target.closest('[data-lw-teil]');
      if (teilZeile && teilZeile.hasAttribute('data-lw-gesperrt')) return;
      if (teilZeile) {
        var an = teilZeile.getAttribute('data-lw-an') !== '1';
        teilZeile.setAttribute('data-lw-an', an ? '1' : '0');
        teilMerken(block, teilZeile.getAttribute('data-lw-id'), an);
        eigenHinweis(block);
        etikettenNachziehen(block);
        adapterpreisZeigen(block);
        preisZeigen(block);
        knopfSetzen(block);
        return;
      }

      var zeile = e.target.closest('.sku__karte');
      if (zeile) { zustand(block).vonHand = true; waehle(block, zeile); return; }

      if (e.target.closest('[data-sku-tab]')) {
        umschalten(block, e.target.closest('[data-sku-tab]').getAttribute('data-sku-tab'));
        return;
      }

      if (e.target.closest('[data-lw-aendern]')) {
        waehle(block, null);
        listeKlappen(block, false);
        mehrRichten(block);
        return;
      }
      if (e.target.closest('[data-lw-mehr]')) {
        var gruppe = aktiveGruppe(block);
        var liste = block.querySelector('[data-sku-reihe="' + gruppe + '"]');
        if (liste) liste.dataset.lwOffen = '1';
        mehrRichten(block);
        return;
      }

      var kasten = e.target.closest('[data-lw-wahl]');
      if (kasten) {
        zustand(block).vomNutzer = true;
        modusSetzen(block, kasten.getAttribute('data-lw-wahl'));
      }
    });

    block.addEventListener('keydown', function (e) {
      if (e.key !== ' ' && e.key !== 'Enter') return;
      var zeile = e.target.closest && e.target.closest('.sku__karte');
      if (!zeile) return;
      e.preventDefault();
      waehle(block, zeile);
    });

    block.addEventListener('change', function (e) {
      var feld = e.target.closest && e.target.closest('[data-lw-variante]');
      if (!feld) return;
      altVariante[feld.getAttribute('data-lw-variante')] = Number(feld.value) || 0;
      zuordnungZeigen(block);
      adapterpreisZeigen(block);
      etikettenNachziehen(block);
      preisZeigen(block);
      knopfSetzen(block);
    });

    document.addEventListener('change', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('form[data-type="add-to-cart-form"]')) {
        adapterpreisZeigen(block);
        setzePreise(block);
        preisZeigen(block);
        summeZeigen(block);
      }
    });
    document.addEventListener('input', function (e) {
      if (e.target && e.target.name === 'quantity') {
        summeZeigen(block);
        knopfSetzen(block);
      }
    });
    document.addEventListener('quantity-selector:update', function (e) {
      if (!e.target || !e.target.closest || !kaufform() || !kaufform().contains(e.target)) return;
      summeZeigen(block);
      knopfSetzen(block);
    });

    function beruehrt() {
      var z = zustand(block);
      if (z.beruehrt) return;
      z.beruehrt = true;
      ungepruefetHinweis(block);
    }
    var setupKasten = block.querySelector('[data-lw-wahl="setup"]');
    if (setupKasten) {
      setupKasten.addEventListener('click', beruehrt, true);
      setupKasten.addEventListener('keydown', beruehrt, true);
    }

    knopfAbfangen(block);
  }

  function alle() {
    document.querySelectorAll('[data-sku]').forEach(aufbauen);
  }

  if (document.readyState !== 'loading') alle();
  else document.addEventListener('DOMContentLoaded', alle);
  document.addEventListener('finder:auswahl', function () {
    document.querySelectorAll('[data-sku]').forEach(function (b) {
      if (b.__lw) b.__lw.vonHand = false;
    });
    if (!auswahlLesen()) {
      lage = 'normal';
      offeneRefs = [];
      offeneNamen = [];
      monitore = [];
      letzteMonitore = '';
    }
    alle();
  });

  document.addEventListener('3idee:passung', function (e) {
    var d = (e && e.detail) || {};
    var ms = d.monitore || [];
    monitore = ms.slice();
    var offen = 0, geloest = 0;
    offeneRefs = []; offeneNamen = [];
    if (ms.length) {
      ms.forEach(function (m) {
        if (!m) return;
        if (m.loesbar === false) {
          offen++;
          if (m.ref != null) offeneRefs.push(String(m.ref));
          if (m.name) offeneNamen.push(m.name);
        } else geloest++;
      });
    } else {
      if (d.stufe === 'warn' && !(d.karten && String(d.karten).trim())) offen = 1;
      else geloest = 1;
    }
    var neu = 'normal';
    if (offen && !geloest) neu = 'sackgasse';
    else if (offen) neu = 'misch';

    var kennung = ms.map(function (m) {
      return (m && m.ref) + ':' + (m && m.stufe) + ':' + (m && m.anzahl || 1);
    }).join('|');

    if (neu !== lage || kennung !== letzteMonitore) {
      if (kennung !== letzteMonitore) {
        document.querySelectorAll('[data-sku]').forEach(teileVergessen);
      }
      lage = neu;
      letzteMonitore = kennung;
      alle();
    }
  });

  document.addEventListener('engine:status', alle);
})();
